// src/app/app.component.ts

import { Renderer2, OnInit, Inject, Component, AfterViewInit } from '@angular/core';
import { NavigationEnd, Event, Router, RouterModule } from '@angular/router'; // Ensure RouterModule is imported
import { TranslateService, TranslateModule } from '@ngx-translate/core'; // Ensure TranslateModule is imported
import { DOCUMENT, CommonModule } from '@angular/common'; // Ensure CommonModule is imported
import { MessagingService } from './services/messaging.service';
import { SpinnerComponent } from './snipper/spinner-component'; // Ensure SpinnerComponent is imported
import { fromEvent, merge, debounceTime, Subscription } from 'rxjs';
import { ApiModulesService } from './services/api-modules.service';
import { SpinnerService } from './snipper/spinner.service';
import { AuthService } from './services/auth.service';

declare const $: any;
declare global {
  interface Window {
    FreshworksWidget: (command: string, ...args: any[]) => void;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [ 
    CommonModule,
    RouterModule,     
    TranslateModule,  
    SpinnerComponent  
  ]
})

export class AppComponent implements OnInit, AfterViewInit {
  title = 'smarthr'; 
  private inactivitySubscription: Subscription;

  message: any;
  url: string;
  user!: { firstName: string; lastName: string; };
  welcome!: string;
  usernameLabel!: string;
  passwordLabel!: string;
  private readonly inactivityTimeout = 8 * 60 * 1000; 

  constructor(private router: Router, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private MessagingService: MessagingService,
    private apiModulesService: ApiModulesService, private spinnerService: SpinnerService, private authService:AuthService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        const url = event.url.split('/');
        this.url = url[1];
        if (
          event.url == '/' ||
          event.url == '/login' ||
          event.url == '/login/register' ||
          event.url == '/login/forgot' ||
          event.url == '/login/otp' ||
          event.url == '/login/lockscreen'
        ) {
          document.querySelector('body')?.classList.add('account-page');
        } else {
          document.querySelector('body')?.classList.remove('account-page');
        }
        if (
          event.url == '/error/error404' ||
          event.url == '/error/error500'
        ) {
          document.querySelector('body')?.classList.add('error-page');
        } else {
          document.querySelector('body')?.classList.remove('error-page');
        }
      }
    });

  }
  ngOnInit() {
    this.setupIdleTimer();
    this.MessagingService.receiveMessage();
    this.message = this.MessagingService.currentMessage;
    $(document).on('click', '#toggle_btn', () => {
      if ($('body').hasClass('mini-sidebar')) {
        $('body').removeClass('mini-sidebar');
        $('.subdrop + ul').slideDown();
      } else {
        $('body').addClass('mini-sidebar');
        $('.subdrop + ul').slideUp();
      }
      return false;
    });

    $(document).on('mouseover', (e) => {
      e.stopPropagation();
      if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
        const targ = $(e.target).closest('.sidebar').length;
        if (targ) {
          $('body').addClass('expand-menu');
          $('.subdrop + ul').slideDown();
        } else {
          $('body').removeClass('expand-menu');
          $('.subdrop + ul').slideUp();
        }
        return false;
      }
    });

    $('body').append('<div class="sidebar-overlay"></div>');
    $(document).on('click', '#mobile_btn', function () {
      var $wrapper = $('.main-wrapper');
      $wrapper.toggleClass('slide-nav');
      $('.sidebar-overlay').toggleClass('opened');
      $('html').addClass('menu-opened');
      $('#task_window').removeClass('opened');
      return false;
    });

    $(".sidebar-overlay").on("click", function () {
      var $wrapper = $('.main-wrapper');
      $('html').removeClass('menu-opened');
      $(this).removeClass('opened');
      $wrapper.removeClass('slide--nav');
      $('.sidebar-overlay').removeClass('opened');
      $('#task_window').removeClass('opened');
    });
  }
  ngAfterViewInit() {
    var currentRoute = window.location.pathname;
    if (currentRoute == '/login' || currentRoute == '/reset/password' || currentRoute == '/forgot/password' || currentRoute == '/new/password/:token') {
      window.FreshworksWidget('hide');
    } else {
      window.FreshworksWidget('hide');
    }
  }
  private setupIdleTimer() {
    const mousemove$ = fromEvent(document, 'mousemove');
    const click$ = fromEvent(document, 'click');
    const keydown$ = fromEvent(document, 'keydown');

    const activity$ = merge(mousemove$, click$, keydown$);

    this.inactivitySubscription = activity$.pipe(
      debounceTime(this.inactivityTimeout)
    ).subscribe(() => {
      this.logoutAndClearSession();
    });
  }


private logoutAndClearSession() {
  let params: any = {};
  params.token = localStorage.getItem('token');
  this.apiModulesService.list('logout', params).subscribe();
  this.authService.clearTokens();
  window.localStorage.removeItem('is_first_login');
  window.localStorage.clear();

  ($('#logout_pop_up') as any).modal('hide');
  this.router.navigateByUrl("/login");
  this.spinnerService.raiseDataEmitterEvent('off');
}
}